import React from "react";

// core components
import { connect } from 'react-redux'
import PropTypes from "prop-types";
import { bindActionCreators }  from 'redux';
import { withRouter } from "react-router-dom";

import { search } from "api/actions";

import { withoutAuth, withSearch, withDropzone, withPreview } from "HOC"

import {
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  UNSTAR_OBJECT_SUCCESS
} from '../../constants/ActionTypes'

import './index.css'
import TruncateLine from "components/TruncateLine";

import MainView from './MainView';

const REQUESTER_ID = 'STARRED'

class Home extends React.Component {
  state = {
    hoveringOver: null,
    selections: [],
    data: []
  };

  componentWillMount() {
    this.setState({ data: [] });
  }

  async componentWillReceiveProps(nextProps) {
    // TODO: Remove this code and do something better.
    // Handle the case where starred items and search bar are using the same event
    if (nextProps.requester !== REQUESTER_ID) {
      return this.setState({
        loading: false
      });
    }

    switch (nextProps.type) {
      case SEARCH:
        this.setState({ loading: true, data: [] });
        break;
      case SEARCH_SUCCESS:
        this.setState({ loading: false, data: nextProps.objects });
        break;
      case SEARCH_FAILURE:
        this.setState({ loading: false });
        break;
      case UNSTAR_OBJECT_SUCCESS:
        await this.removeItem(nextProps.unstarredKey);
        break;  
    }
  }

  getObjects = (info = {}) => {
    info.starred = true;
    this.props.search(info, REQUESTER_ID);
  };

  removeItem = (id) => new Promise(resolve => {
    this.setState({
      data: [].concat(this.state.data.filter(data => data.id !== id)),
    }, resolve);
  })

  render() {
    return (
      <MainView
        objects={this.state.data}
        location={this.props.location}
        loading={this.state.loading}
        page={this.state.page}
        getObjects={this.getObjects}
        showPreview={(id) => {
          if (this.props.showPreview) {
            this.props.getObjectDownload({ id });
            this.props.showPreview();
          }
        }}
        unstarredKey={this.props.unstarredKey}
        type={this.props.type}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage,
  objects: state.objects,
  unstarredKey: state.unstarredKey,
  requester: state.requester,
  type: state.type,
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ search }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(
  withRouter(
    withDropzone(
      Home
    )
  )
)
